module.exports = __webpack_public_path__ + "static/assets/83aad438a547a9dfd34794368ac3b643.png";